import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SimOuNao } from 'src/app/core/enums/sim-ou-nao.enum';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent {

  @Input() options = new SimOuNao().getAll();
  @Input() name = '';
  @Input() label = '';
  @Input() form: FormGroup;

}
